import { useState, useEffect } from 'react';
import { useAuthStore } from '../stores/authStore.js';
import { TAB_EDITS_CHANGED_EVENT } from '../sync/events.js';
import { hasUnseenDecisions } from '../db/tabEdits.js';

export function useUnseenEdits(): boolean {
  const { user, isGuest, isAuthenticated } = useAuthStore();
  const [hasUnseen, setHasUnseen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || isGuest || !user?.id) {
      setHasUnseen(false);
      return;
    }

    let active = true;

    const check = async () => {
      try {
        const unseen = await hasUnseenDecisions(user.id);
        if (active) {
          setHasUnseen(unseen);
        }
      } catch {
        // ignore Dexie errors in private mode/during teardown
      }
    };

    void check();

    const handleChanged = () => {
      void check();
    };

    window.addEventListener(TAB_EDITS_CHANGED_EVENT, handleChanged);
    window.addEventListener('focus', handleChanged);

    return () => {
      active = false;
      window.removeEventListener(TAB_EDITS_CHANGED_EVENT, handleChanged);
      window.removeEventListener('focus', handleChanged);
    };
  }, [user?.id, isGuest, isAuthenticated]);

  return hasUnseen;
}
